import { MpsUser } from '../models/mps-user.model';
import { RoleEnum } from '../../mps/enums/roles.enum';

export class PermissionsHelper {
  private static readonly forbiddenBackofficeRoles = [
    RoleEnum.USER, RoleEnum.TTE_DEPOT_OPERATOR, RoleEnum.REVALIDATOR,
    RoleEnum.MANUFACTURER, RoleEnum.POINT_OF_SALE_REP,
  ];
  private static readonly cylinderManagementRoles = [
    RoleEnum.ADMIN, RoleEnum.AFFILIATE_ADMIN, RoleEnum.AFFILIATE_VIEWER,
    RoleEnum.STOCK_ACCOUNTANT, RoleEnum.SITE_ADMIN, RoleEnum.SITE_SUPERVISOR,
  ];
  private static readonly stoRoles = [
    RoleEnum.ADMIN, RoleEnum.AFFILIATE_ADMIN, RoleEnum.AFFILIATE_VIEWER,
    RoleEnum.STOCK_ACCOUNTANT, RoleEnum.SITE_ADMIN, RoleEnum.SITE_SUPERVISOR,
  ];
  private static readonly incidentManagementRoles = [
    RoleEnum.ADMIN,
    RoleEnum.AFFILIATE_ADMIN, RoleEnum.AFFILIATE_VIEWER,
    RoleEnum.SITE_ADMIN, RoleEnum.SITE_SUPERVISOR, RoleEnum.STOCK_ACCOUNTANT,
  ];
  private static readonly adminRoles = [RoleEnum.ADMIN, RoleEnum.AFFILIATE_ADMIN];
  private static readonly UserManagementRoles = [RoleEnum.ADMIN, RoleEnum.AFFILIATE_ADMIN, RoleEnum.SITE_ADMIN];

  private static readonly ownLocationAbleRoles = [
    RoleEnum.SITE_ADMIN, RoleEnum.SITE_SUPERVISOR, RoleEnum.TTE_DEPOT_OPERATOR, RoleEnum.STOCK_ACCOUNTANT,
  ];
  private static readonly readonlyRoles = [
    RoleEnum.AFFILIATE_VIEWER, RoleEnum.SITE_SUPERVISOR, RoleEnum.STOCK_ACCOUNTANT
  ];

  public static canChangeAffiliate(user: MpsUser): boolean {
    return user.isAdmin() || user.isStockAccountant();
  }

  static userCanImportUsers(user: MpsUser): boolean {
    return user.isAdmin() || user.isAffiliateAdmin();
  }

  static canAccessBackofficeApp(user: MpsUser): boolean {
    return !this.forbiddenBackofficeRoles.includes(user.role.code.toUpperCase() as RoleEnum);
  }

  static canAccessCylinderManagement(user: MpsUser) {
    return this.canAccessPage(user, this.cylinderManagementRoles);
  }

  static canAccessSto(user: MpsUser) {
    return this.canAccessPage(user, this.stoRoles);
  }

  static canAccessIncidentManagement(user: MpsUser): boolean {
    return this.canAccessPage(user, this.incidentManagementRoles);
  }

  static canAccessAdmin(user: MpsUser): boolean {
    return this.canAccessPage(user, this.adminRoles);
  }

  static canAccessUserManagement(user: MpsUser): boolean {
    return this.canAccessPage(user, this.UserManagementRoles);
  }

  static userCanEditInStoManagement(user: MpsUser): boolean {
    return this.userCannotDo(user, this.readonlyRoles);
  }

  static userCanEditInCylinderManagement(user: MpsUser): boolean {
    return this.userCannotDo(user, this.readonlyRoles);
  }

  static userCanOnlySeeOwnDefaultLocation(user: MpsUser): boolean {
    return (this.ownLocationAbleRoles as string[]).includes(user.role.code.toUpperCase());
  }

  private static userCannotDo(user: MpsUser, concernedRoles: string[]): boolean {
    return !concernedRoles.includes(user.role.code.toUpperCase());
  }

  private static canAccessPage(user: MpsUser, roles: string[]): boolean {
    return user?.role && roles.includes(user.role.code.toUpperCase());
  }
}
